import { Component, h, Prop } from '@stencil/core';
import { CmsLinkConfig, Logger } from '../../../global/_types';

@Component({
  tag: 'cms-link-element',
  styleUrl: 'cms-link-element.scss',
  shadow: false,
})
export class CmsLinkElement {
  @Prop() config: string | CmsLinkConfig;
  @Prop() debug: boolean = false;

  private logger: Logger;

  /* Config */
  private options: CmsLinkConfig;

  componentWillLoad() {
    this.logger = new Logger(this.debug, 'CmsLinkElement');
  }

  // Force content update on each render call
  componentWillRender() {
    this.options = typeof(this.config) === 'string' ?
      JSON.parse(this.config) as CmsLinkConfig :
      this.config;
  }

  componentDidLoad() {
    this.logger.trace('CmsLinkElement loaded');
  }

  render() {
    if(this.options?.link && this.options?.link != "") {
      return (
        <a
          href={this.options.link}
          title={this.options.label}
          target={this.options.target}
          class={this.options.class}
          id={this.options.sectionId}
          data-gtmid={this.options.gtmId}
          download={this.options.dam ? "download" : null}
        >
          <slot />
        </a>
      );
    } else {
      return (
        <span><slot /></span>
      );
    }
  }
}
